{
	"addBillSuccessNotification": "Bill created successfully.",
	"printTitle": {
		"any": "All bills",
		"toPay": "Bills to pay",
		"toReceive": "Bills to receive",
		"transfer": "Transfer",
		"default": "Bills"
	},
	"printTitleCaps": {
		"any": "ALL BILLS",
		"toPay": "BILLS TO PAY",
		"toReceive": "BILLS TO RECEIVE",
		"transfer": "TRANSFERS"
	},
	"competence": "Competence",
	"dueDate": "Due date",
	"addBill": "Add bill",
	"importSpreadsheet": "Import spreadsheet",
	"exportSpreadsheet": "Export spreadsheet",
	"addTransfer": "Add transfer",
	"modalTransfer": {
		"add": "Add transfer",
		"edit": "Edit transfer",
		"description": "Description",
		"date": "Date",
		"value": "Value",
		"paid": "Paid?",
		"sourceAccount": "Origin account",
		"destinationAccount": "Destination account"
	},
	"tableBill": {
		"description": "Description",
		"performDate": "Competency date",
		"dueDate": "Due date",
		"account": "Receiving account",
		"value": "Value",
		"paid": "Paid?",
		"expireToday": "Expires today",
		"expired": "Expired",
		"notInformed": "Not informed"
	},
	"tableTransfer": {
		"description": "Description",
		"date": "Date",
		"value": "Value",
		"sourceAccount": "Origin account",
		"destinationAccount": "Destination account",
		"paid": "Paid?",
		"actions": "Actions",
		"popConfirm": "Are you sure you want to delete this transfer?"
	},
	"billFields": {
		"description": "Description",
		"value": "Value",
		"dueDate": "Competence Date",
		"payDate": "Payday",
		"performDate": "Due date",
		"supplier": "Supplier",
		"account": "Account",
		"category": "Category",
		"accountType": "Account Type",
		"costCenter": "Cost center",
		"paymentMethod": "Payment method",
		"observation": "Observation",
		"interest": "Fees",
		"fine": "Fine",
		"discount": "Discount",
		"reconciled": "Reconciled",
		"payed": "Paid?",
		"filename": "exampleOfAccounts"
	}
}
